import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

export const getMenuItems = async (): Promise<any> => {
  const url = `${API_URL}/items`;
  return fetch(url, {
    method: 'GET',
  });
};
